// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
    width: 100%;
    font-family: 'Roboto', 'RobotoFallback', 'Noto Kufi Arabic', 'Helvetica', 'Arial', sans-serif;
    font-weight: 40;
    font-size: 12px;
    color: #0000009b;
    text-align: center;
    max-width: 95%; /* Limit width to 90% */
    margin: auto; /* Center horizontally */
    border-top: 1px solid #ccc; /* Add top border */
    padding-top: 10px; /* Add padding at top */
    margin-top: 20px; /* Add margin at top */
    padding-bottom: 20px; /* Add padding at bottom */
  }

  .link-style {
    color: #03a9f4;
    text-decoration: none;
    margin-right: 5px; /* Add margin between links */
    margin-left: 5px; /* Add margin between links */
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,6FAA6F;IAC7F,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc,EAAE,uBAAuB;IACvC,YAAY,EAAE,wBAAwB;IACtC,0BAA0B,EAAE,mBAAmB;IAC/C,iBAAiB,EAAE,uBAAuB;IAC1C,gBAAgB,EAAE,sBAAsB;IACxC,oBAAoB,EAAE,0BAA0B;EAClD;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB,EAAE,6BAA6B;IAChD,gBAAgB,EAAE,6BAA6B;EACjD","sourcesContent":[".footer-container {\n    width: 100%;\n    font-family: 'Roboto', 'RobotoFallback', 'Noto Kufi Arabic', 'Helvetica', 'Arial', sans-serif;\n    font-weight: 40;\n    font-size: 12px;\n    color: #0000009b;\n    text-align: center;\n    max-width: 95%; /* Limit width to 90% */\n    margin: auto; /* Center horizontally */\n    border-top: 1px solid #ccc; /* Add top border */\n    padding-top: 10px; /* Add padding at top */\n    margin-top: 20px; /* Add margin at top */\n    padding-bottom: 20px; /* Add padding at bottom */\n  }\n\n  .link-style {\n    color: #03a9f4;\n    text-decoration: none;\n    margin-right: 5px; /* Add margin between links */\n    margin-left: 5px; /* Add margin between links */\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
